var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06113 2.3661V4.39913L3.15002 7.89357H0.877796C0.644485 7.89226 0.42123 7.80841 0.256773 7.66034C0.0923153 7.51226 1.30803e-05 7.31198 1.76947e-05 7.10322V0.790366C-0.00072015 0.686391 0.0216242 0.58332 0.0657546 0.487133C0.109885 0.390945 0.174923 0.303555 0.257095 0.230032C0.339268 0.15651 0.436939 0.0983179 0.544443 0.0588329C0.651947 0.019348 0.767144 -0.000644344 0.883351 1.58321e-05H4.41113L7.06113 2.3661ZM6.39446 2.76376L3.97224 0.591536V2.76376H6.39446ZM3.52941 10V8.79403L7.50468 5.23722L8.85253 6.44319L4.87726 10H3.52941ZM9.89487 5.05712C10.035 5.18254 10.035 5.38515 9.89487 5.51057L9.23711 6.09908L7.88926 4.89311L8.54701 4.3046C8.68719 4.17918 8.91363 4.17918 9.05381 4.3046L9.89487 5.05712Z",
    fill: "#0C6052"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagNote);
export default __webpack_public_path__ + "static/media/tag_note.b8d34d0fb026e05d64351ee577eb5dac.svg";
export { ForwardRef as ReactComponent };